
import * as __star__ from '@clayui/icon';

const {
default: __default__,
ClayIconSpriteContext,
__esModule
} = __star__;

export {
ClayIconSpriteContext,
__esModule
};
export default __default__;
